import { CONFIG } from '../config';

export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => CONFIG.IMAGE_TAG === 'production';

export const isLocalhost = () =>
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
